import React from "react";

import { ApiServicesProvider } from "@/modules/app/apiServicesContext";
import GraphServiceProvider from "./GraphServiceProvider";
import AuthProvider from "@/modules/auth/useAuth";
import SessionProvider from "@/modules/app/SessionProvider";
import GeoLocationProvider from "@/modules/app/GeoLocationProvider";
import AuthStateProvider from "@/modules/auth/useAuthState";

const ComposedProvider: React.FC = ({ children }) => {
  return (
    <ApiServicesProvider>
      <AuthStateProvider>
        <GraphServiceProvider>
          <AuthProvider>
            <SessionProvider>
              <GeoLocationProvider>{children}</GeoLocationProvider>
            </SessionProvider>
          </AuthProvider>
        </GraphServiceProvider>
      </AuthStateProvider>
    </ApiServicesProvider>
  );
};

export default ComposedProvider;
